<template>
    <section v-if="Error">
        <v-dialog v-model="Error" width="500" persistent>
            <v-card>
                <v-card-title class="error-title" v-html="Error.title"></v-card-title>
                <v-card-text>
                    <v-icon>mdi-accept</v-icon>
                    <p v-html="Error.msg"/>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <Button :click="() => Close()">Cerrar</Button>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </section>
</template>

<script>
import Button from './Button.vue';
export default {
  components: { Button },
    computed:
    {
        Error()
        {
            return this.$store.state.Misc.Error;
        }
    },
    methods:
    {
        Close()
        {
            this.$store.commit("Misc/setError",undefined);
        }
    }
}
</script>

<style scoped>
.error-title
{
    display: grid;
    text-align: center;
    justify-content: center;
}
</style>